import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePlanning } from '../contexts/PlanningContext';
import { BattlePlan } from '../types/planning.types';
import { format } from 'date-fns';

interface CreatePlanModalProps {
  onClose: () => void;
}

export default function CreatePlanModal({ onClose }: CreatePlanModalProps) {
  const navigate = useNavigate();
  const { createPlan } = usePlanning();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: format(new Date(), 'yyyy-MM-dd'),
    status: 'draft' as BattlePlan['status'],
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.title.trim()) return;

    setLoading(true);
    try {
      const planId = await createPlan({
        ...formData,
        participants: [],
        subjects: [],
      });
      onClose();
      navigate(`/plans/${planId}`);
    } catch (error) {
      console.error('Error creating plan:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">תוכנית חדשה</h2>
          <button
            className="btn btn-icon"
            onClick={onClose}
            style={{ fontSize: '1.5rem', opacity: 0.5 }}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label">כותרת התוכנית *</label>
              <input
                type="text"
                className="form-input"
                placeholder="לדוגמה: תוכנית רבעון Q1"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label className="form-label">תיאור</label>
              <textarea
                className="form-textarea"
                placeholder="תיאור קצר של התוכנית..."
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                rows={3}
              />
            </div>

            <div className="form-group">
              <label className="form-label">תאריך</label>
              <input
                type="date"
                className="form-input"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label className="form-label">סטטוס</label>
              <select
                className="form-select"
                value={formData.status}
                onChange={(e) => setFormData({ ...formData, status: e.target.value as BattlePlan['status'] })}
              >
                <option value="draft">טיוטה</option>
                <option value="active">פעיל</option>
              </select>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || !formData.title.trim()}
            >
              {loading ? 'יוצר...' : 'צור תוכנית'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              ביטול
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
